// A calendar day the way a buyer reads it: "October 5, 2025", never "2025-10-05"
// (Ryan's ruling; Lane 1382 for the supplier dossier's Delivery tab). The API keeps its
// ISO values; only the words on screen change.
//
// The day is read from the first ten characters ("2025-10-05", or the date part of a
// timestamp such as "2026-09-30T14:02:00+00:00") as a calendar day, so no time zone can
// move it to the day before. A value that is not a date gives null, never a guess.

const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})/;

function calendarDay(value) {
  const m = ISO_DAY.exec(String(value || ''));
  if (!m) return null;
  const day = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3])));
  // 2025-02-31 is not a day: Date would roll it into March.
  if (day.getUTCFullYear() !== Number(m[1]) || day.getUTCMonth() !== Number(m[2]) - 1
    || day.getUTCDate() !== Number(m[3])) return null;
  return day;
}

function words(day) {
  return day.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}

export function plainDate(value) {
  const day = calendarDay(value);
  return day ? words(day) : null;
}

// The last day of a window whose end is exclusive ("before 2026-10-05" is "through
// October 4, 2026").
export function plainDayBefore(value) {
  const day = calendarDay(value);
  if (!day) return null;
  day.setUTCDate(day.getUTCDate() - 1);
  return words(day);
}
